import { render } from "./SectionContainer.vue?vue&type=template&id=5a50cc38"
import script from "./SectionContainer.vue?vue&type=script&lang=js"
export * from "./SectionContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__